import { render, staticRenderFns } from "./HollowCalendarIcon.vue?vue&type=template&id=1d0d4340&"
import script from "./HollowCalendarIcon.vue?vue&type=script&lang=ts&"
export * from "./HollowCalendarIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports